import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import "./style.scss";


export const ContactDetails = props => {

  useEffect(() => { });

  return (
    <div className="contact-details">
      <Row>
        <a href={`mailto:${props.values.contact_email}`}>
          <Col role="img" aria-label={`mail:${props.values.contact_email}`} className="icon email" tabIndex="0">{props.values.contact_email}</Col>
        </a>
      </Row>
      <Row>
        <a href={`tel:${props.values.contact_number}`}>
          <Col role="img" aria-label={`tel:${props.values.contact_number}`} className="icon phone" tabIndex="0">{props.values.contact_number}</Col>
        </a>
      </Row>
      <Row>
        <Col role="img" aria-label={props.values.contact_time} className="icon time" tabIndex="0">{props.values.contact_time}</Col>
      </Row>
      <Row>
        <a href={`https://tau-int.formtitan.com/ftproject/CRM_TAU_guest`} >
          <Col role="img" aria-label={props.values.more_details} className="icon more-details" tabIndex="0">{props.values.more_details}</Col>
        </a>
      </Row>
      {/* {/* <Row>
        <Col  className="icon chat" tabIndex="0">{props.values.contact_chat}</Col>
      </Row> */}
      <Row>
        <a href={`https://api.whatsapp.com/send?phone=972522995818`} >
          <Col role="img" aria-label={`${props.values.contact_whatsapp}:972522995818`} className="icon whatsapp" tabIndex="0">{props.values.contact_whatsapp}</Col>
        </a>
      </Row>
      <Row>
        <div
          role="img"
          aria-label={props.values.consulting}
          className="icon consulting"
          dangerouslySetInnerHTML={{
            __html: props.values.consulting || '<div></div>'
          }}
        ></div>
      </Row>
      <Row>
        <a href="https://www.tor4you.co.il/edstn.asp?siteid=6187&sid=94C73DB429ACD0A6" aria-label={props?.values?.improvementMeeting} className="bottom-text" tabIndex="0">{props?.values?.improvementMeeting}</a>
      </Row>
    </div>
  );
};
